import { useQuery } from "@tanstack/react-query"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { getUseCase } from "../api/use-cases-api"

export function useUseCase(id: string | null) {
  return useQuery({
    queryKey: useCasesQueryKeys.detail(id ?? ""),
    queryFn: () => getUseCase(id!),
    enabled: !!id,
    staleTime: 30_000,
  })
}
